import React, { memo } from 'react'

const ManageCookies = memo(({ name }) => (
  <div>
    <h2>{name}</h2>
    <p>This is {name} component</p>
  </div>
))

ManageCookies.displayName = 'ManageCookies'

export default ManageCookies
